import { AppEnv } from 'coreOld/enums';
import { APP_ENV, DOMAIN_URL } from 'global';
import { BASE_ROUTE } from 'router/constants';

export const getDomainUrl = () => {
  if (APP_ENV === AppEnv.DEVELOPMENT) {
    return DOMAIN_URL;
  }

  return window.location.origin;
};

export const getDomainHost = () => {
  if (APP_ENV === AppEnv.DEVELOPMENT) {
    const regex = new RegExp('https://([^/]+)');

    return regex.exec(DOMAIN_URL)[1];
  }

  return window.location.host;
};

export const goTo = (url: string) => {
  window.location.assign(url);
};

export const getPath = (pathName: string) => [BASE_ROUTE, pathName].join('');
